module.exports = __webpack_public_path__ + "static/img/blog-9.7fa28160.webp";